/**
 * Ryan O'Dowd
 * 2024-01-20
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import globals from '@utils/globals';

const getStyles = ({fonts, globalScale, colors, isDarkMode}) => {
  return {
    messageWrapper: {
      paddingTop: globalScale * 4,
      paddingLeft: globalScale * 16,
      paddingBottom: globalScale * 4,
      paddingRight: globalScale * 16,
      flexDirection: 'row',
    },
    myMessageWrapper: {
      justifyContent: 'flex-end',
    },
    otherMessageWrapper: {
      justifyContent: 'flex-start',
    },
    messageWrapperInner: {
      maxWidth: '80%', // @TODO: is this a good percentage on all devices? feel like right margin would be cleaner
    },
    messageSenderName: {
      paddingLeft: globalScale * 4,
      paddingRight: globalScale * 4,
      fontSize: globalScale * 12,
      color: globals.appName === 'tibbits' ? (isDarkMode ? colors.white : colors.black) : colors.white,
    },
    messageBody: {
      flex: 1,
      flexDirection: 'row',
      fontSize: globalScale * 16,
      padding: globalScale * 8,
      borderRadius: globalScale * 8,
      overflow: 'hidden',
      fontFamily: fonts.primary,
    },
    messageBodyLink: {
      color: colors.accentLight,
    },
    myMessage: {
      backgroundColor: colors.primaryExtraDark,
      color: colors.white,
      alignSelf: 'flex-end',
    },
    otherMessage: {
      backgroundColor: colors.primaryDark,
      color: colors.white,
      alignSelf: 'flex-start',
    },
    senderIsMeText: {
      textAlign: 'right',
    },
    senderIsNotMeText: {
      textAlign: 'left',
    },
    swipeoutButtonView: {
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      backgroundColor: null,
    },
    timestampText: {
      width: '100%',
      marginLeft: globalScale * 8,
      color: globals.appName === 'tibbits' ? (isDarkMode ? colors.white : colors.black) : colors.white,
      textAlign: 'center',
    },
    // @TODO: combine with wrinkly
    popover: {
      backgroundColor: isDarkMode ? colors.bgDark : colors.white,
      borderRadius: globalScale * 12, // @TODO: global scale okay here?
      borderWidth: 1,
      borderBottomWidth: 1,
      borderColor: isDarkMode ? colors.white : colors.primary,
      borderBottomColor: isDarkMode ? colors.white : colors.primary,
    },
    contextMenuRow: {
      flexDirection: 'row',
      alignItems: 'center',
      flexShrink: 1,
      marginLeft: 0,
      paddingLeft: 0,
    },
    divider: {
      width: 1,
      height: globalScale * 22,
      backgroundColor: isDarkMode ? colors.white : colors.primary,
      margin: 2,
    },
    contextMenuButton: {
      margin: 2,
      marginTop: 0,
      marginBottom: 0,
    },
    contextMenuButtonSelected: {
      backgroundColor: colors.accentLight,
    },
    touchableWrapper: {
      alignItems: 'flex-end',
    },
    senderIsMeTouchableWrapper: {
      alignItems: 'flex-start',
    },
    reactionIconContainer: {
      marginBottom: globalScale * -16,
      marginRight: globalScale * -16,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.accentLight,
      padding: globalScale * 4,
      width: globalScale * 32,
      height: globalScale * 32,
      borderRadius: globalScale * 16,
      zIndex: 100,
    },
    senderIsMeReactionIconContainer: {
      marginLeft: globalScale * -16,
      marginRight: undefined,
    },
    reactionIcon: {
      color: isDarkMode ? colors.primaryLight : colors.primary,
      fontSize: globalScale * 20,
    },
    adminWrapper: {
      paddingLeft: 4,
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
    versionText: {
      color: colors.gray,
      fontSize: 10,
    },
    platformIcon: {
      color: colors.lightGray,
      fontSize: 10,
    },
  };
};

export default getStyles;
